import React from "react";
import { Link } from "react-router-dom";

import logo from "../assets/adaptive-icon.png";

const Header = () => {
  return (
    <header className="header">
      <Link className="header__logo" to={"/"}>
        <img src={logo} alt="PetGeo" className="header__logo-image" />

        <div className="header__logo-text">PetGeo</div>
      </Link>

      <div className="header__links">
        <Link className="header__link" to={"/faq"}>
          Faq
        </Link>

        <Link className="header__link" to={"/privacy"}>
          Privacy
        </Link>
      </div>
    </header>
  );
};

export default Header;
